import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.admin.cache');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-admin-cache',
template: templateSource || '',
    styles: [``],
})
export class PortalAdminCacheComponent implements OnInit {
    public rows: any[] = [];
    public metadataRows: any[] = [];
    public summary: any = {
        file_count: 0,
        total_size: 0,
        location_count: 0,
        existing_location_count: 0,
        primary_path: '',
        primary_source: '',
        primary_retention: '',
        primary_file_count: 0,
        primary_total_size: 0,
    };
    public loading: boolean = false;
    public clearing: boolean = false;
    public deleting: boolean = false;
    public error: string = '';
    public resultMessage: string = '';
    public showClearConfirm: boolean = false;
    public showDeleteConfirm: boolean = false;
    public deleteTarget: any = null;
    public showPreview: boolean = false;
    public previewLoading: boolean = false;
    public previewError: string = '';
    public preview: any = null;
    public previewTarget: any = null;
    public previewFile: any = null;
    public adminRoute: string = '/admin/data/cache';
    public listApiRoute: string = '/wiz/api/page.admin/cache_files';
    public cacheFilePath: string = '/opt/app/data/serarch';
    public cachePathSource: string = 'src/app/page.search/api.py:KEYWORD_RESULT_CACHE_DIR';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadCaches();
    }

    private apiUrl(fn: string) {
        return `/wiz/api/page.admin/${fn}`;
    }

    private async readJson(resp: Response) {
        const text = await resp.text();
        let json: any = null;
        try {
            json = text ? JSON.parse(text) : null;
        } catch (e) {
            throw new Error(`응답을 해석하지 못했습니다. (${resp.status})`);
        }
        if (!resp.ok) {
            const message = json?.data?.message || json?.message || `요청 실패 (${resp.status})`;
            throw new Error(message);
        }
        return json;
    }

    private async postForm(fn: string, params: Record<string, any> = {}) {
        const body = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => body.set(key, String(value ?? '')));
        const resp = await fetch(this.apiUrl(fn), {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString(),
        });
        return await this.readJson(resp);
    }

    private responseMessage(json: any, fallback: string) {
        return json?.data?.message || json?.message || fallback;
    }

    private responseCodeMessage(json: any, fallback: string) {
        const code = json?.code ?? 'unknown';
        return this.responseMessage(json, `${fallback} (응답 코드: ${code})`);
    }

    private errorMessage(error: any, fallback: string) {
        return error?.message || fallback;
    }

    public async loadCaches() {
        this.loading = true;
        this.error = '';
        await this.service.render();

        try {
            const json = await this.postForm('cache_files');
            if (json?.code === 200 && json.data) {
                this.rows = json.data.rows || [];
                this.metadataRows = this.collectMetadataRows(this.rows);
                this.summary = json.data.summary || this.summary;
                if (json.data.message) {
                    this.error = json.data.message;
                }
            } else if (json?.code === 401) {
                this.rows = [];
                this.metadataRows = [];
                this.error = this.responseMessage(json, '로그인이 필요합니다. 다시 로그인 후 새로고침해 주세요.');
            } else {
                this.metadataRows = [];
                this.error = this.responseCodeMessage(json, `캐시 파일 경로 ${this.cacheFilePath} 조회 응답이 정상 처리되지 않았습니다.`);
            }
        } catch (e) {
            this.metadataRows = [];
            this.error = this.errorMessage(e, `캐시 파일 경로 ${this.cacheFilePath} 조회 요청 중 오류가 발생했습니다.`);
        }

        this.loading = false;
        await this.service.render();
    }

    public openClearConfirm() {
        if (!this.summary?.file_count || this.clearing) return;
        this.showClearConfirm = true;
        this.resultMessage = '';
        this.service.render();
    }

    public closeClearConfirm() {
        if (this.clearing) return;
        this.showClearConfirm = false;
        this.service.render();
    }

    public async clearAllCaches() {
        this.clearing = true;
        this.error = '';
        this.resultMessage = '';
        await this.service.render();

        try {
            const json = await this.postForm('cache_clear_all');
            if (json?.code === 200 && json.data) {
                this.rows = json.data.rows || [];
                this.metadataRows = this.collectMetadataRows(this.rows);
                this.summary = json.data.summary || this.summary;
                const count = json.data.deleted_count || 0;
                const size = this.formatSize(json.data.deleted_size || 0);
                const errors = json.data.errors || [];
                this.resultMessage = errors.length
                    ? `${this.formatNumber(count)}개 삭제, 일부 실패 ${this.formatNumber(errors.length)}건`
                    : `${this.formatNumber(count)}개 캐시 파일 삭제 완료 (${size})`;
            } else {
                this.error = this.responseMessage(json, '캐시 삭제에 실패했습니다.');
            }
        } catch (e) {
            this.error = this.errorMessage(e, '캐시 삭제에 실패했습니다.');
        }

        this.clearing = false;
        this.showClearConfirm = false;
        await this.service.render();
    }

    public openMetadataDeleteConfirm(meta: any) {
        if (!meta?.file_path || this.deleting) return;
        this.deleteTarget = meta;
        this.showDeleteConfirm = true;
        this.error = '';
        this.resultMessage = '';
        this.service.render();
    }

    public closeMetadataDeleteConfirm() {
        if (this.deleting) return;
        this.showDeleteConfirm = false;
        this.deleteTarget = null;
        this.service.render();
    }

    public async deleteMetadataCache() {
        const meta = this.deleteTarget;
        const row = this.metadataLocationRow(meta);
        if (!row || !meta?.file_path) {
            this.error = '삭제할 캐시 파일 정보를 찾을 수 없습니다. 새로고침 후 다시 확인해 주세요.';
            this.showDeleteConfirm = false;
            this.deleteTarget = null;
            await this.service.render();
            return;
        }

        this.deleting = true;
        this.error = '';
        this.resultMessage = '';
        await this.service.render();

        try {
            const json = await this.postForm('cache_file_delete', {
                key: row.key,
                path: meta.file_path,
            });
            if (json?.code === 200 && json.data) {
                this.rows = json.data.rows || [];
                this.metadataRows = this.collectMetadataRows(this.rows);
                this.summary = json.data.summary || this.summary;
                this.resultMessage = `${this.metadataKeyword(meta)} 캐시 삭제 완료 (${this.metadataFileSize(meta)})`;
                this.showDeleteConfirm = false;
                this.deleteTarget = null;
            } else {
                this.error = this.responseMessage(json, '캐시 파일 삭제에 실패했습니다.');
                this.showDeleteConfirm = false;
                this.deleteTarget = null;
            }
        } catch (e) {
            this.error = this.errorMessage(e, '캐시 파일 삭제에 실패했습니다.');
            this.showDeleteConfirm = false;
            this.deleteTarget = null;
        }

        this.deleting = false;
        await this.service.render();
    }

    public async openPreview(row: any, file: any) {
        if (!row?.key || !file?.relative_path) return;
        this.showPreview = true;
        this.previewLoading = true;
        this.previewError = '';
        this.preview = null;
        this.previewTarget = row;
        this.previewFile = file;
        await this.service.render();

        try {
            const json = await this.postForm('cache_file_preview', {
                key: row.key,
                path: file.relative_path,
            });
            if (json?.code === 200 && json.data) {
                this.preview = json.data;
            } else {
                this.previewError = this.responseMessage(json, '파일 미리보기를 불러오지 못했습니다.');
            }
        } catch (e) {
            this.previewError = this.errorMessage(e, '파일 미리보기를 불러오지 못했습니다.');
        }

        this.previewLoading = false;
        await this.service.render();
    }

    private metadataLocationRow(meta: any): any {
        return (this.rows || []).find((item: any) => item?.key === meta?.location_key) || this.connectedRow();
    }

    public async openMetadataPreview(meta: any) {
        const row = this.metadataLocationRow(meta);
        if (!row || !meta?.file_path) return;
        await this.openPreview(row, {
            relative_path: meta.file_path,
            size: meta.file_size,
            modified: meta.file_modified,
        });
    }

    public closePreview() {
        if (this.previewLoading) return;
        this.showPreview = false;
        this.previewError = '';
        this.preview = null;
        this.previewTarget = null;
        this.previewFile = null;
        this.service.render();
    }

    public formatNumber(value: any): string {
        const num = Number(value || 0);
        return num.toLocaleString('ko-KR');
    }

    public formatSize(bytes: any): string {
        const value = Number(bytes || 0);
        if (value < 1024) return `${value} B`;
        const units = ['KB', 'MB', 'GB', 'TB'];
        let size = value / 1024;
        let idx = 0;
        while (size >= 1024 && idx < units.length - 1) {
            size = size / 1024;
            idx += 1;
        }
        return `${size.toFixed(size >= 10 ? 1 : 2)} ${units[idx]}`;
    }

    private collectMetadataRows(rows: any[]): any[] {
        const result: any[] = [];
        (rows || []).forEach((row: any) => {
            (row?.files || []).forEach((file: any) => {
                const metadata = file?.metadata || null;
                if (!metadata || Object.keys(metadata).length === 0) return;
                result.push({
                    ...metadata,
                    file_path: file.relative_path || metadata.filename || '',
                    file_size: file.size || metadata.file_size || 0,
                    file_modified: file.modified || metadata.modified || '',
                    location_key: row?.key || '',
                    location_label: row?.label || '',
                });
            });
        });
        return result;
    }

    private metadataOf(value: any): any {
        return value?.metadata || value || {};
    }

    private metadataValues(value: any, field: string, limit: number = 4): string {
        const meta = this.metadataOf(value);
        const values = Array.isArray(meta[field]) ? meta[field] : [];
        return values.slice(0, limit).join(', ') || '-';
    }

    public metadataId(value: any): string {
        const meta = this.metadataOf(value);
        return meta.json_id || '-';
    }

    public metadataKeyword(value: any): string {
        const meta = this.metadataOf(value);
        const primary = Array.isArray(meta.primary_keywords) ? meta.primary_keywords : [];
        const keywords = Array.isArray(meta.keywords) ? meta.keywords : [];
        return meta.search_keyword || meta.original_keyword || primary[0] || keywords[0] || '-';
    }

    public metadataSort(value: any): string {
        const meta = this.metadataOf(value);
        const sort = meta.sort || '-';
        const order = meta.order || '';
        return order ? `${sort} ${order}` : sort;
    }

    public metadataResultCount(value: any): string {
        const meta = this.metadataOf(value);
        const count = meta.result_count;
        if (count === undefined || count === null || count === '') return '-';
        return this.formatNumber(count);
    }

    public metadataKeywordList(value: any): string {
        return this.metadataValues(value, 'keywords');
    }

    public metadataFacetOrgs(value: any): string {
        return this.metadataValues(value, 'facet_orgs');
    }

    public metadataFacetKeywords(value: any): string {
        return this.metadataValues(value, 'facet_keywords');
    }

    public metadataFileSize(value: any): string {
        const size = value?.file_size ?? value?.metadata?.file_size ?? 0;
        return this.formatSize(size || 0);
    }

    public statusClass(row: any): string {
        if (!row?.path_exists) return 'bg-gray-100 text-gray-400 border-gray-200';
        if (row?.exists) return 'bg-emerald-50 text-emerald-600 border-emerald-200';
        return 'bg-slate-50 text-slate-500 border-slate-200';
    }

    public statusLabel(row: any): string {
        if (!row?.path_exists) return '경로 없음';
        if (row?.exists) return '파일 있음';
        if (row?.connected) return '저장된 캐시 없음';
        return '비어 있음';
    }

    public connectedRow(): any {
        return (this.rows || []).find((row: any) => row?.connected) || null;
    }
}

export default PortalAdminCacheComponent;